import type { ManageAccessStep } from '@/types/manage-access.types';
import { resolveWizardStepStatus } from '@/utils/wizard.utils';

export const resolveManageAccessWizardStepStatus = resolveWizardStepStatus;

export type ManageAccessWizardStepKey = ManageAccessStep;

export interface ManageAccessWizardStepMeta {
  stepNumber: number;
  label: ManageAccessWizardStepKey;
}

export const MANAGE_ACCESS_WIZARD_STEPS: ManageAccessWizardStepMeta[] = [
  { stepNumber: 1, label: 'Owners' },
  { stepNumber: 2, label: 'Members' },
  { stepNumber: 3, label: 'External' },
  { stepNumber: 4, label: 'Review' },
];

const MANAGE_ACCESS_STEP_NUMBER_MAP = new Map<ManageAccessStep, number>(
  MANAGE_ACCESS_WIZARD_STEPS.map((step) => [step.label, step.stepNumber]),
);

export function resolveManageAccessWizardStepNumber(step: ManageAccessStep): number {
  return MANAGE_ACCESS_STEP_NUMBER_MAP.get(step)
    ?? MANAGE_ACCESS_WIZARD_STEPS[MANAGE_ACCESS_WIZARD_STEPS.length - 1].stepNumber;
}
